/* PhonePartPro — infinite scroll + device-compatibility filter for collection pages */
(function () {
  'use strict';

  /* ---------- Device compatibility filter ---------- */
  document.querySelectorAll('.ppp-compat').forEach(function (wrap) {
    var sel = wrap.querySelector('.ppp-compat__select');
    var base = wrap.getAttribute('data-base') || '';
    if (!sel) return;
    sel.addEventListener('change', function () {
      var v = sel.value;
      window.location.href = v ? base.replace(/\/+$/, '') + '/' + v : base;
    });
  });

  /* ---------- Infinite scroll ---------- */
  var grid = document.getElementById('product-grid');
  if (!grid || grid.classList.contains('collection--empty')) return;

  // Find the "next page" URL by PAGE NUMBER — robust regardless of Dawn's
  // (inverted, misleading) pagination class names.
  function pageNum(url) {
    var m = /[?&]page=(\d+)/.exec(url || '');
    return m ? parseInt(m[1], 10) : 1;
  }
  function nextUrlFrom(doc) {
    var pager = doc.querySelector('.pagination-wrapper');
    if (!pager) return null;
    var cur = parseInt(pager.getAttribute('data-page') || '1', 10) || 1;
    var links = pager.querySelectorAll('a.pagination__item[href]');
    for (var i = 0; i < links.length; i++) {
      if (pageNum(links[i].getAttribute('href')) === cur + 1) {
        return links[i].getAttribute('href');
      }
    }
    return null;
  }

  var pager = document.querySelector('.pagination-wrapper');
  var nextUrl = nextUrlFrom(document);
  if (!nextUrl) return;            // single page — nothing to do
  if (pager) pager.style.display = 'none';

  var loading = false;
  var done = false;

  // Sentinel placed after the grid; when it enters view we load more.
  var sentinel = document.createElement('div');
  sentinel.className = 'ppp-infinite-sentinel';
  sentinel.innerHTML = '<span class="ppp-infinite-spinner" hidden>Loading more&hellip;</span>';
  grid.parentNode.insertBefore(sentinel, grid.nextSibling);
  var spinner = sentinel.querySelector('.ppp-infinite-spinner');

  function loadMore() {
    if (loading || done || !nextUrl) return;
    loading = true;
    if (spinner) spinner.hidden = false;
    fetch(nextUrl, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          var items = newGrid.querySelectorAll('.grid__item');
          var frag = document.createDocumentFragment();
          items.forEach(function (li) { frag.appendChild(li); });
          grid.appendChild(frag);
        }
        nextUrl = nextUrlFrom(doc);
        if (!nextUrl) { done = true; observer.disconnect(); sentinel.remove(); }
      })
      .catch(function () { /* network hiccup — allow retry on next intersection */ })
      .finally(function () {
        loading = false;
        if (spinner) spinner.hidden = true;
      });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) loadMore(); });
  }, { rootMargin: '600px 0px' });
  observer.observe(sentinel);
})();
